import { TEAMS, type Team } from './stickers';

export const GROUP_ORDER = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'] as const;
export type TournamentGroup = typeof GROUP_ORDER[number];

export interface ConfederationGroup {
  code: TournamentGroup;
  label: string;
  teams: Team[];
}

export function groupTeamsByConfederation(): ConfederationGroup[] {
  return GROUP_ORDER.map((code) => ({
    code,
    label: `Grupo ${code}`,
    teams: TEAMS.filter((t) => t.group === code),
  })).filter((g) => g.teams.length > 0);
}
